'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as React from 'react';
import clsx from 'clsx';
import styled from '@mui/styled-engine';
import styleFunctionSx, { extendSxProp } from "../styleFunctionSx/index.js";
import useTheme from "../useTheme/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function createBox() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var themeId = options.themeId, defaultTheme = options.defaultTheme, _options_defaultClassName = options.defaultClassName, defaultClassName = _options_defaultClassName === void 0 ? 'MuiBox-root' : _options_defaultClassName, generateClassName = options.generateClassName;
    var BoxRoot = styled('div', {
        shouldForwardProp: function(prop) {
            return prop !== 'theme' && prop !== 'sx' && prop !== 'as';
        }
    })(styleFunctionSx);
    var Box = /*#__PURE__*/ React.forwardRef(function Box(inProps, ref) {
        var theme = useTheme(defaultTheme);
        var _extendSxProp = extendSxProp(inProps), className = _extendSxProp.className, _extendSxProp_component = _extendSxProp.component, component = _extendSxProp_component === void 0 ? 'div' : _extendSxProp_component, other = _object_without_properties(_extendSxProp, [
            "className",
            "component"
        ]);
        return /*#__PURE__*/ _jsx(BoxRoot, _object_spread({
            as: component,
            ref: ref,
            className: clsx(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}
